// KEEP THIS

import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// NOTE: this is for the ADMIN charity care application form creation page.
// for the charity care application form page, see charity_care_application_form_fields_controller.js
// Connects to data-controller="charity-care-application-field"
export default class extends Controller {
  static targets = [
    "fieldType",
    "statusLabel",
    "form",
    "chooseCoordinatesLabel",
    "chosenCoordinates",
    "chosenCoordinateDetails",
    "chooseCoordinatesContainer",
    "chooseCoordinatesRemaining",
    "numCoordsPerRow",
    "fieldDetails",
    "tableDetails",
    "tableHasRowLabels",
    "numColumns",
    "numRows",
    "columnLabels",
    "rowLabels",
    "rowLabelsContainer",
    "originalLabel",
    "canonicalFieldName",
    "submitButton"
  ]

  static values = {
    fieldId: Number,
    formId: Number,
  }

  initialize() {
    this.boundListener = this.listener.bind(this);
  }

  connect() {
    this.remainingCoordinatesToChoose = 1;

    var top = this.element.querySelector("#charity_care_application_field_original_label_top").value;
    var left = this.element.querySelector("#charity_care_application_field_original_label_left").value;
    var pageNumber = this.element.querySelector("#charity_care_application_field_page_number").value;

    let elm = document.getElementById("charity_care_application_field_bounding_box_" + top + "_" + left + "_" + pageNumber);
    if (elm) {
      elm.style.backgroundColor = "rgba(0, 255, 0, 0.5)";
    }

    if (this.chosenCoordinateDetailsTarget.querySelectorAll("input").length == 0) {
      this.submitButtonTarget.disabled = true;
    }

    this.changeFieldType();
  }

  changeFieldType(e) {
    if (this.fieldTypeTarget.value == "Boolean") {
      this.numCoordsPerRowTarget.value = 2;
    } else if (this.fieldTypeTarget.value === "Signature" || this.fieldTypeTarget.value === "Signed at") {
      if (this.canonicalFieldNameTarget.value.length === 0) {
        this.submitButtonTarget.disabled = true;
      } else {
        this.submitButtonTarget.disabled = false;
      }
    } else {
      this.submitButtonTarget.disabled = false;
    }

    if (this.fieldTypeTarget.value === "Table") {
      this.tableDetailsTarget.classList.remove("hidden");
      this.fieldDetailsTarget.classList.add("hidden");

      if (this.columnLabelsTarget.innerHTML.trim().length == 0) {
        this.numColumnsChanged();
        this.numRowsChanged();
      }
    } else {
      this.tableDetailsTarget.classList.add("hidden");
      this.fieldDetailsTarget.classList.remove("hidden");
    }
  }

  tableHasRowLabelsChanged(e) {
    if (this.tableHasRowLabelsTarget.value == "true") {
      this.rowLabelsContainerTarget.classList.remove("hidden");
    } else {
      this.rowLabelsContainerTarget.classList.add("hidden");
    }
  }

  numColumnsChanged(e) {
    var numColumns = parseInt(this.numColumnsTarget.value);
    var columnLabels = this.columnLabelsTarget;
    columnLabels.innerHTML = "";
    for (var i = 0; i < numColumns; i++) {
      var newLabel = `<div><input type="text" name="table_column_labels[]" data-action="click->charity-care-application-forms#setActiveElement"></div>`;
      columnLabels.innerHTML += newLabel;
    }
  }

  numRowsChanged(e) {
    var numRows = parseInt(this.numRowsTarget.value);

    var rowLabels = this.rowLabelsTarget;
    rowLabels.innerHTML = "";
    for (var i = 0; i < numRows; i++) {
      var newLabel = `<div><input type="text" name="table_row_labels[]" data-action="click->charity-care-application-forms#setActiveElement"></div>`;
      rowLabels.innerHTML += newLabel;
    }
  }

  changeCanonicalFieldName(e) {
    if (this.canonicalFieldNameTarget.value.length > 0) {
      this.submitButtonTarget.disabled = false;
    } else if (this.fieldTypeTarget.value === "Signature" || this.fieldTypeTarget.value === "Signed at") {
      this.submitButtonTarget.disabled = true;
    }
  }

  beginChoosingCoordinates(e) {
    var totalCoordinates = this.numCoordsPerRowTarget.value;
    this.remainingCoordinatesToChoose = totalCoordinates;
    this.chooseCoordinatesRemainingTarget.innerHTML = this.remainingCoordinatesToChoose + " remaining";

    var label = this.chooseCoordinatesLabelTarget;

    this.chosenCoordinatesTarget.innerHTML = "";
    this.chosenCoordinateDetailsTarget.innerHTML = "";

    // reset all placeholder inputs for this field
    if (this.fieldIdValue) {
      Array.from(document.getElementsByClassName("input-container")).forEach((elm) => {
        if (Number(elm.dataset["fieldId"]) === this.fieldIdValue) {
          elm.remove()
        }
      })
    }

    // give some feedback that we're now choosing coordinates
    label.style.color = "red";

    // make all the bounding box divs not clickable
    var boundingBoxes = document.getElementsByClassName("charity_care_application_field_bounding_box");

    for (var i = 0; i < boundingBoxes.length; i++) {
      boundingBoxes[i].style.pointerEvents = "none";
    }

    // watch all the clicks on the png preview pages. when clicked, grab the coords and page number and add to the form targets, make the bounding box divs clickable again
    var previewPages = document.getElementsByClassName("charity_care_application_form_preview_page");
    for (var i = 0; i < previewPages.length; i++) {
      previewPages[i].addEventListener("click", this.boundListener);
    }
  }

  listener(event) {
    this.remainingCoordinatesToChoose -= 1;
    this.chooseCoordinatesRemainingTarget.innerHTML = this.remainingCoordinatesToChoose + " remaining";

    // get the coords
    var x = event.offsetX;
    var y = event.offsetY;
    var pageNumber = event.target.dataset['pageNumber'];

    // convert the coordinates, currently in pixels, to points
    var xPercent = x / event.target.width;
    var yPercent = y / event.target.height;

    var xConversionFactor;
    var yConversionFactor;
    if (event.target.height > event.target.width) {
      xConversionFactor = 612;
      yConversionFactor = 792;
    } else {
      xConversionFactor = 792;
      yConversionFactor = 612;
    }

    var xPts = xPercent * xConversionFactor;
    var yPts = yConversionFactor - (yPercent * yConversionFactor);

    // Add hidden elements to the form
    var hiddenInputX = document.createElement("input");
    hiddenInputX.setAttribute("type", "hidden");
    hiddenInputX.setAttribute("name", "charity_care_application_field[coordinates][][bottom_left_x_pt]");
    hiddenInputX.setAttribute("value", xPts);
    this.chosenCoordinateDetailsTarget.appendChild(hiddenInputX);

    var hiddenInputY = document.createElement("input");
    hiddenInputY.setAttribute("type", "hidden");
    hiddenInputY.setAttribute("name", "charity_care_application_field[coordinates][][bottom_left_y_pt]");
    hiddenInputY.setAttribute("value", yPts);
    this.chosenCoordinateDetailsTarget.appendChild(hiddenInputY);

    var hiddenInputPageNumber = document.createElement("input");
    hiddenInputPageNumber.setAttribute("type", "hidden");
    hiddenInputPageNumber.setAttribute("name", "charity_care_application_field[coordinates][][page_number]");
    hiddenInputPageNumber.setAttribute("value", pageNumber);
    this.chosenCoordinateDetailsTarget.appendChild(hiddenInputPageNumber);

    var newCoords = `<div class="mt-2">${parseInt(xPts)}, ${parseInt(yPts)}: <input type="text" name="charity_care_application_field[labels][]" placeholder="label" data-action="focus->charity-care-application-forms#setActiveElement"></div>`;
    this.chosenCoordinatesTarget.innerHTML += newCoords;
    this.submitButtonTarget.disabled = false;

    if (this.remainingCoordinatesToChoose == 0) {
      var boundingBoxes = document.getElementsByClassName("charity_care_application_field_bounding_box");
      for (var j = 0; j < boundingBoxes.length; j++) {
        boundingBoxes[j].style.pointerEvents = "auto";
      }

      this.chooseCoordinatesLabelTarget.style.removeProperty("color");
      this.remainingCoordinatesToChoose = 1;
      this.chooseCoordinatesRemainingTarget.innerHTML = "";
      var previewPages = document.getElementsByClassName("charity_care_application_form_preview_page");
      for (var j = 0; j < previewPages.length; j++) {
        previewPages[j].removeEventListener("click", this.boundListener);
      }
    }
  }

  editTableField(e) {
    e.preventDefault();

    var button = e.target.closest("button");

    // Submit as a Turbo request
    const formId = button.getAttribute("data-form-id");
    const tableFieldId = button.getAttribute("data-table-field-id");
    const url = `/admin/charity_care_application_forms/${formId}/charity_care_application_fields/${tableFieldId}/edit_table_cell`;

    const fetchParams = {
      method: 'post',
      body: JSON.stringify({
        row_index: button.getAttribute("data-row-index"),
        column_index: button.getAttribute("data-column-index"),
      }),
      headers: {
        "Content-Type": "application/json",
        Accept: "text/vnd.turbo-stream.html"
      }
    };

    fetch(url, fetchParams)
      .then(response => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }

}

